import './cookiesBar.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Container } from 'components/base';

const CookiesBar = props => {
  if (props.allowCookies) {
    return null;
  }

  const handleOnAllowCookies = e => {
    e.preventDefault();

    props.onAllowCookies();
  };

  return (
    <div className="cookies-bar">
      <Container className="container">
        <Typography.H4>This website uses cookies</Typography.H4>
        <Typography.P className="small text-justify">
          <Button type="warning" size="sm" onClick={handleOnAllowCookies}>
            Allow All Cookies
          </Button>
          We use cookies to offer you a better experience and to analyze site traffic. By continuing
          to browse this site, you agree to this use of cookies.
        </Typography.P>
      </Container>
    </div>
  );
};

CookiesBar.propTypes = {
  allowCookies: PropTypes.bool,
  onAllowCookies: PropTypes.func,
};

export default CookiesBar;
